export default `
  <h1>什么是基础代谢率(BMR)？</h1>
  <p>基础代谢率(Basal Metabolic Rate)是指人体在清醒而又极端安静的状态下，不受肌肉活动、环境温度、食物及精神紧张等影响时的能量代谢率。</p>
  <p>基础代谢率对减肥有非常大的影响，每天适量的运动有助于提高身体的基础代谢率，而极端的节食会降低人的基础代谢率。</p>
  <p>通过性别、年龄、身高和体重能粗略计算出基础代谢率</p>
`;
